class ShopTheLook extends HTMLElement {
  connectedCallback() {
    this.pins = Array.from(this.querySelectorAll('[data-shop-look-pin]'));
    this.cards = Array.from(this.querySelectorAll('[data-shop-look-card]'));

    if (!this.pins.length || !this.cards.length) return;

    this.pins.forEach((pin) => {
      pin.addEventListener('mouseenter', () => this.activate(pin.dataset.shopLookPin, false));
      pin.addEventListener('focus', () => this.activate(pin.dataset.shopLookPin, false));
    });

    this.cards.forEach((card) => {
      const blockId = card.dataset.shopLookCard;

      card.addEventListener('mouseenter', () => this.activate(blockId, false));
      card.addEventListener('focusin', () => this.activate(blockId, false));
      card.addEventListener('click', (event) => {
        if (event.target.closest('a')) return;
        this.activate(blockId, false);
      });
    });

    this.activate(this.pins[0].dataset.shopLookPin, false);
  }

  activate(blockId, shouldScrollCard) {
    this.pins.forEach((pin) => {
      pin.classList.toggle('is-active', pin.dataset.shopLookPin === blockId);
    });

    this.cards.forEach((card) => {
      const isActive = card.dataset.shopLookCard === blockId;
      card.classList.toggle('is-active', isActive);

      if (isActive && shouldScrollCard) {
        card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }
    });
  }
}

if (!customElements.get('shop-the-look')) {
  customElements.define('shop-the-look', ShopTheLook);
}
